export default __webpack_public_path__ + "static/edit-photos-30d4b0fbe9873ae8be451a99bdcfd505.png";